<template>
  <zen-one 
  :showuserinfo="false" 
  title="iBAYAQ"
  :crumbs="crumbs"
  >
    <z-page
    title="Pengurusan iBayaq - Mengenai Kami"
    >
        <div class="card-body card-scroll">
            <div class="row" style="width:100%;overflow:hidden;">
                <div class="col-6" style="width:49%;float: left;">

                    <div class="card">
                        <div class="w-flex table-bar-search-title">
                            <h4 class="card-title">Gambar</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group col-md-12" style="padding-bottom:7%;background:#f1f5fb;">
                                <div class="input-group">
                                    <img v-if="image != ''" class="img-fluid" :src="image" style="max-height:250px;">
                                    <input @change="handleFileUpload" type="file" accept="image/*" />
                                </div>
                            </div>
                            <div class="w-card table-bar-search-bottom text-right" style="padding-top:5px;padding-bottom:5px;">
                                <button class="w-button w-button--dark size--md indigo-dark2--bg ml1" type="button" @click="save()">Simpan</button>
                            </div>
                        </div>
                    </div>

                </div>
                <div style="margin-left:50%">

                    <div class="card">
                        <div class="w-flex table-bar-search-title">
                            <h4 class="card-title">Mengenai Kami</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group col-md-12" style="padding-bottom:15px;background:#f1f5fb;">
                                <div class="input-group">
                                    <ckeditor :editor="editor" v-model="form.mainpage_content" :config="editorConfig"></ckeditor>
                                </div>
                            </div>
                            <div class="w-card table-bar-search-bottom text-right" style="padding-top:5px;padding-bottom:5px;">
                                <button class="w-button w-button--dark size--md indigo-dark2--bg ml1" type="button" @click="save()">Simpan</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        
    </z-page>
  </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

	export default {
    extends: ZResource,
	setup () {

	},
	props: {
		// about: [Array, Object],
	},
	data() {
	    return {
			editor: ClassicEditor,
			form: {
                mainpage_content: '',
                image: [],
            },
            image: '',
			editorConfig: {

			},
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: '/sitemap' },
                // { label: 'Utama', route: '/' },
                { label: 'Pengurusan iBayaq', route: '/ibayaq/about_us' },
                { label: 'Mengenai Kami', route: '/ibayaq/about_us' }
            ],
		}},
	methods: {
        getData() {
            this.$zcomm
                .get(this.service_ibayaq + "cms/about_us")
                .then((res) => {
                    this.form.mainpage_content = res.about.content;
                    this.image = String(this.service_ibayaq).replace('/api/','')+res.about.image;
                })
                .catch((err) => {})
                .finally(() => {});
        },
        handleFileUpload(e) {
            this.form.image = e.target.files[0];
            console.log(this.form.image);
        },
		save(){
            let formData = new FormData();
            if(this.form.image)
                formData.append("image", this.form.image);
            formData.append("mainpage_content", this.form.mainpage_content);
			this.$zcomm.post(this.service_ibayaq + "cms/about_us/save", formData)
            .then((res) => {
                alert("Rekod Telah Berjaya Disimpan");
                this.getData();
            });
			
		},
	},
	mounted() {
        this.getData();
		// override default setting
        // console.log(Ziggy.routes);
	}
}
</script>